module.exports = __webpack_public_path__ + "static/img/food-img-1.fbf4651.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/food-img-1.png
// module id = nNRs
// module chunks = 1